/** Valeur interne du select pour « Autre » */
export const REUNION_LIEU_AUTRE = '__autre__';

/** Lieux proposés dans le formulaire réunion (ordre d’affichage) */
export const REUNION_LIEUX_PREDEFINIS = [
  "Chambre d'Agriculture, 24 rue de la Source à Saint-Denis (Salle Bibliothèque au rez de chaussée)",
  'Miellerie collective AMAIR de la Plaine des Cafres',
  'Salle Raymond Barre à la Mairie de Bras-Panon',
  'Salle du Pôle municipal au Tampon',
  'Siège de la Coopémiel au 9, rue de la Compagnie des Indes ZAC Grègues à Saint-Joseph',
  '5 rue Arzal Adolphe à la Plaine des Palmistes',
];

export const resolveReunionLieuFromForm = (lieuSelectKey, lieuAutre) => {
  if (lieuSelectKey === REUNION_LIEU_AUTRE) {
    return (lieuAutre || '').trim();
  }
  return (lieuSelectKey || '').trim();
};

export const reunionLieuFormFromStored = (lieu) => {
  if (!lieu) {
    return { lieuSelectKey: '', lieuAutre: '' };
  }
  if (REUNION_LIEUX_PREDEFINIS.includes(lieu)) {
    return { lieuSelectKey: lieu, lieuAutre: '' };
  }
  return { lieuSelectKey: REUNION_LIEU_AUTRE, lieuAutre: lieu };
};
